import { CommunicationModal } from '@/components/communication/communication-modal.tsx';

import { ModalType } from '@/models/Modal.ts';
import { CommunicationContext } from '@/models/communication-context.ts';

import { openModal } from '@/services/modalService.tsx';

interface OpenCommunicationModalOptions {
    context: CommunicationContext;
    /**
     * Called with the entry text after a successful save, when the user chose "+ Aufgabe erstellen". What
     * that turns into is the caller's business — this modal knows nothing about tasks.
     */
    onSavedWithTask: (content: string) => void;
}

export const openCommunicationModal = ({ context, onSavedWithTask }: OpenCommunicationModalOptions): void => {
    openModal({
        modalId: ModalType.COMMUNICATION,
        title: <>Kommunikation</>,
        size: 'lg',
        children: <CommunicationModal context={context} onSavedWithTask={onSavedWithTask} />,
    });
};
